module.exports = __webpack_public_path__ + "static/media/rapid.9bb61c82.svg";